import Modal, { ModalBody, ModalHeader, Sheets } from '@ingka/modal';
import { translate } from '@repo/phrase';

import { Attachments } from './attachments.component';

interface Props {
    visible: boolean;
    onClose: () => void;
    shouldOpenUploadDialog?: boolean;
    onUploadDialogRequestHandled?: () => void;
}

export const AttachmentsModal = ({
    visible,
    onClose,
    shouldOpenUploadDialog = false,
    onUploadDialogRequestHandled,
}: Props) => {
    return (
        <Modal handleCloseBtn={onClose} visible={visible}>
            <Sheets
                size="medium"
                aria-label={translate('asset_details_attachments')}
                header={<ModalHeader title={translate('asset_details_attachments')} />}
                footer={null}
            >
                <ModalBody>
                    <Attachments
                        shouldOpenUploadDialog={shouldOpenUploadDialog}
                        {...(onUploadDialogRequestHandled && { onUploadDialogRequestHandled })}
                    />
                </ModalBody>
            </Sheets>
        </Modal>
    );
};
